import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterPerfilOpciones from 'views/security/perfilopciones/filterPerfilOpciones'; // Importing filter options component
import TablePerfilOpciones from 'views/security/perfilopciones/tablePerfilOpciones'; // Importing table component for profile options
import DetailsPerfilOpciones from 'views/security/perfilopciones/detailsPerfilOpciones'; // Importing details component for profile options
import RecordPerfilOpciones from 'views/security/perfilopciones/recordPerfilOpciones'; // Importing record component for profile options
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for profile options.
 * @extends JetView
 */
export default class PerfilOpcionesView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view layout.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section containing players view and details
        const right = {
            type: 'wide',
            rows: [PlayersView, DetailsPerfilOpciones, RecordPerfilOpciones],
        };

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: 15, // Number of items per page
                },
            ],
        };

        // Left section containing toolbar and table
        const left = {
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label',
                            label: _('Perfil Opciones'), // Label for the profile options
                            width: 200,
                        },
                    ],
                },
                TablePerfilOpciones, // Table for displaying profile options
                toolbar, // Including the toolbar
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main layout configuration
        return {
            type: 'wide',
            responsive: true,
            css: 'out', // CSS class for the main layout
            cols: [
                left, // Left section
                { view: 'resizer' }, // Resizer between left and right sections
            ],
        };
    }
}

// FILE DOCUMENTED
